<!-- ParentLayout.vue -->
<template>
    <div class="parent-layout">
      <!-- 内容区域 -->
      <main class="content-container">
        <router-view />
      </main>
  
      <!-- 家长端专属底部导航 -->
  
      <!-- route
        fixed
        safe-area-inset-bottom
        active-color="#1989fa"
        inactive-color="#7d7e80" -->

<van-tabbar v-model="active" route fixed safe-area-inset-bottom >
    <van-tabbar-item icon="friends-o" replace to="/parentHomePage" class="tabbarLi">
    <span>首页</span>
    <template #icon="props">
      <img  class="tabbarLiImg"  :src="props.active ? require('@/assets/icon/首页选中.png') :  require('@/assets/icon/首页.png')" />
    </template>
  </van-tabbar-item>

  <van-tabbar-item icon="friends-o" replace to="/sportStar">
    <span>运动之星</span>
    <template #icon="props">
      <img  class="tabbarLiImg" :src="props.active ? require('@/assets/icon/运动之星选中.png') :  require('@/assets/icon/运动之星.png')" />
    </template>
  </van-tabbar-item>
  

 <!-- <van-tabbar-item icon="friends-o" replace  to="/integralShop/shop">
    <span>积分商城</span>
    <template #icon="props">
      <img  class="tabbarLiImg" :src="props.active ? require('@/assets/icon/商城选中.png') :  require('@/assets/icon/商城.png')" />
    </template>
  </van-tabbar-item>  -->
  <van-tabbar-item icon="setting-o"  replace to="/parentCenter"  :badge="studentStatusData.homeStatus">
    <span>个人中心</span>
    <template #icon="props">
      <img  class="tabbarLiImg" :src="props.active ? require('@/assets/icon/个人选中.png') :  require('@/assets/icon/个人.png')" />
    </template>
  </van-tabbar-item>
</van-tabbar> 
    </div>
  </template>
  
<script>
import {insertBaseSystemAccountWx,listRotationChart} from '@/api/common'
import VDialog from "@/components/VDialog";
import { getEduYearList} from "@/api/resultReporting.js";
import { getStudentStatus} from "@/api/parentHomePage.js";

export default {
  components: {
    VDialog
  },
  data() {
    return {
      active:'',
     countAll:undefined,
     objData: {
        checked: false,
        num: 3,
        showDialog: false,
      },
 
menuList:[
  
],
termCode:'',
termName:'',
    studentTitleInfo:{},
    studentStatusData:{}
    }
  },
  computed: {

  },
  created() {
  },
 async mounted () {
    this.studentTitleInfo = sessionStorage.getItem('studentTitleCard')?JSON.parse(sessionStorage.getItem('studentTitleCard')):{}
    if (this.studentTitleInfo.schoolCode&&this.studentTitleInfo.schoolCode!=='') {
       await this.getEduYearList()
    this.getStudentStatus()
    }
   
    this.init()
     
  },
  methods: {
           // 查询学年
 async getEduYearList(){
  
 await getEduYearList({
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
          }).then(res=>{  
            res.data.data?.forEach(el=>{
                  el.text = el.name
              if(+el.isActive==1){
                  this.termCode = el.code
                  this.termName = el.name
              }
            })
          })
 },
      getStudentStatus(){
      getStudentStatus({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
        
      }).then(res=>{
        console.log(1111111111111111111111);
        
        this.$set(this.studentStatusData,"faceStatus",res.data.body.faceStatus)
        if (+res.data.body.homeStatus==2) {
        this.$set(this.studentStatusData,"homeStatus",1)
        }else{
        this.$set(this.studentStatusData,"homeStatus","")
        }
        
      })
    },
   async studentChange(val){
    this.studentTitleInfo =val
  
  },
  onReport(){
      let data = JSON.stringify({...this.studentTitleInfo, })
      this.$router.push({path:'fitnessReport',query:{data:data}})
  },
  onbodyReport(){
      let data = JSON.stringify({...this.studentTitleInfo,})
      this.$router.push({path:'bodyForging',query:{data:data}})
  },
    init(){
       const isChecked = localStorage.getItem("isChecked") || false;
        if (!isChecked) {
          this.objData.showDialog = true;
          if (this.$refs.VDialog && this.$refs.VDialog.countdown) {
            this.$refs.VDialog.countdown();
          }
        }
          
    },
      goswiper(val){
    // this.$router.push({path:url})
      },
goPage(val){
let url = ''
if (val.name=='学生绑定') {
 url = '/studentBind'
}
else if (val.name=='测训准考证') {
  url = '/admissionTicket'
 }else if (val.name=='家庭作业') {
  url = '/homework'
 }else if (val.name=='健康信息申报') {
  url = '/surveyMgt'
 }else if (val.name=='阳光跑') {
  url = '/sunrunScore'
 }else if (val.name=='积分商城') {
  url = '/integralShop'
 }else if (val.name=='运动分析') {
  url = '/fitnessReportV2'
 }

 
 
if (url!=='') {
    this.$router.push({path:url})
}else  {
  this.$toast({ icon: "error", message: "暂未开放，敬请期待！！" });
}
},

  }
};
</script>
  <style scoped>
  .parent-layout {
    position: relative;
    height: 100vh;


  }
  /* 适配全面屏手机底部安全区域 */
 .parent-layout {
  /* padding-bottom: constant(safe-area-inset-bottom); */
  /* padding-bottom: env(safe-area-inset-bottom); */
} 
 .tabbarLi{
  /* margin: 10px 0; */
 }
 .tabbarLiImg{
  width: 30px;
  height: 30px;
 }
 .van-tabbar {
  height: 60px;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  /* 兼容 iOS 安全区 */
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  /* padding-bottom: 25px;  */
  box-sizing: content-box;
 }
  .content-container {
    padding-bottom: 80px;
    /* height: 100%; */
    height: calc(100% - 80px);
    overflow-y: auto;

      /* 让内容不被tabbar遮挡 */
   /* padding-bottom: calc(60px + env(safe-area-inset-bottom));  */
   /* padding-bottom: calc(60px + constant(safe-area-inset-bottom));  */
  }
  </style>